import React from "react";

import "./keywords.css";
import KeywordDisplay from "./keywordDisplay";

interface KeywordsProps {
    keywords: string[];
}

export default function Keywords(props: KeywordsProps) {
    return (
        <div className="keywords">
            {props.keywords.map((keyword, index) => (
                <KeywordDisplay key={index} name={keyword}/>
            ))}
        </div>
    );
}